import React from 'react';
import Children from '../../interfaces/children.interface';
import ClassName from '../../interfaces/class-name.interface';
import Gap from '../../interfaces/gap.interface';
import Layer from '../../interfaces/layer.interface';
import TestId from '../../interfaces/test-id.interface';
import Icon from '../icon/icon.component';
import Size from '../../interfaces/size.interface';

export interface Props extends Children, ClassName, Gap, Layer, Size, TestId {
  /** An optional icon to render above the content */
  icon?: string;

  /** The cards title */
  title?: React.ReactNode;

  /** Render the card horizontally/vertically */
  layout?: 'col' | 'row';
}

const Card = ({
  children,
  className = '',
  gap = 'none',
  icon,
  layer = 2,
  layout = 'col',
  size = '2xl',
  title,
  testId,
}: Props): React.ReactElement => (
  <div
    className={`
      card
      ${icon ? 'card--icon' : ''}
      card--${layout}
      card--${size}
      flex
      flex-${layout}
      bg-white
      min-w-sm
      ${['xs', 'sm', 'base'].includes(size) ? 'p-4' : 'p-8'}
      ${layout === 'col' ? 'text-center max-w-md' : ''}
      gap--${gap}
      layer--${layer}
      ${className}
    `}
    data-testid={testId}
  >
    {icon && (
      <Icon
        className={`self-center ${layout === 'row' ? 'mr-8' : ''}`}
        name={icon}
        size={['xs', 'sm', 'base'].includes(size) ? '2xl' : '4xl'}
        color="gray-900"
        variant="circle"
        gap={layout === 'col' ? 'l' : 'none'}
      />
    )}
    <div>
      {title && (
        <strong
          className={`block text-${size} ${['xs', 'sm', 'base'].includes(size) ? 'mb-2' : 'mb-4'}`}
        >
          {title}
        </strong>
      )}
      <div className={`text-gray-700 ${['xs', 'sm', 'base'].includes(size) ? 'text-xs' : ''}`}>
        {children}
      </div>
    </div>
  </div>
);

export default Card;
